import {SupportedNetwork} from 'src/types';
import {eth, polygon, base, sol} from '@sail/icons/react/BrandIcon';
import {absurd} from 'src/utils/absurd';

const EVM_CHAIN_ID_MAPPING: {
  [chainId: number]: SupportedNetwork;
} = {
  1: 'ethereum',
  11155111: 'ethereum',
  137: 'polygon',
  80002: 'polygon',
  8453: 'base',
  84532: 'base',
};

export const getNetworkFromChainId = (
  chainId: number,
): SupportedNetwork | undefined => {
  return EVM_CHAIN_ID_MAPPING[chainId];
};

export const getChainIdFromNetwork = (
  network: SupportedNetwork,
  livemode = false,
): number => {
  // Return the appropriate chain ID based on network and environment
  switch (network) {
    case 'ethereum':
      return livemode ? 1 : 11155111;
    case 'polygon':
      return livemode ? 137 : 80002;
    case 'base':
      return livemode ? 8453 : 84532;
    default:
      throw new Error(`Unsupported network: ${network}`);
  }
};

export const getNetworkNameForLivemode = (
  network: SupportedNetwork,
  livemode: boolean,
): string => {
  switch (network) {
    case 'ethereum':
      return livemode ? 'Ethereum' : 'ETH Sepolia';
    case 'polygon':
      return livemode ? 'Polygon' : 'POL Amoy';
    case 'solana':
      return livemode ? 'Solana' : 'SOL Devnet';
    case 'base':
      return livemode ? 'Base' : 'BASE Sepolia';
    default:
      throw new Error('Unsupported network');
  }
};

export const getNetworkName = (network: SupportedNetwork): string => {
  switch (network) {
    case 'ethereum':
      return 'Ethereum';
    case 'polygon':
      return 'Polygon';
    case 'solana':
      return 'Solana';
    case 'base':
      return 'Base';
    default:
      throw new Error('Unsupported network');
  }
};

export const getNetworkIcon = (network: SupportedNetwork) => {
  switch (network) {
    case 'ethereum':
      return eth;
    case 'polygon':
      return polygon;
    case 'base':
      return base;
    case 'solana':
      return sol;
    default:
      return absurd(network);
  }
};

export const getReadableNetworkType = (network: SupportedNetwork): string => {
  return network === 'solana' ? 'Solana' : 'EVM';
};
